import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}
export function Button({
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  children,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50';
  const variants = {
    primary: 'bg-terracotta text-white hover:bg-terracotta-hover hover:-translate-y-0.5 hover:shadow-md',
    secondary: 'bg-sage text-white hover:bg-sage-dark hover:-translate-y-0.5 hover:shadow-md',
    outline: 'border-2 border-sage text-sage hover:bg-sage/10',
    ghost: 'text-teal hover:bg-neutral-soft'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-193">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-194" />}
      {children}
    </button>;
}